import Vue from "vue";
import { convertToString, convertToReadableDate } from "../utils/DateConverter";
import { addFieldToList } from "@/utils/FieldFormatter.js"
import * as _ from "lodash";

export const mutations = {
	// only used for removing the manager persona for testing access permissions
	resetPersonas: (state, scenarioName) => {
		state[scenarioName].userPersonas = ['QDU Exceptions'];
	},

	setUsers: (state, payload) => {
		state.users = payload;
	},

	setScenario: (state, payload) => { // payload is {scenario: scenarioName(string), data: scenarioData}
		// sets the scenario
		state[payload.scenario] = payload.data;
		if (state[payload.scenario].runBetaRules === undefined) {
			state[payload.scenario].runBetaRules = true;
		}
		console.log("scenario data", state[payload.scenario]);
		// state.toolScenario.fields[(payload.data.fields.length)-1] = testCreditReportField;
	},

	// TODO: change this to take just the milliseconds
	setIsLegacyLoan: (state, payload) => { // payload.data is milliseconds UTC time of loan created date
		// checks if the date the loan was created is before the legacy cutoff date
		// if you change the cutoff date make sure the test reflects the new date
		const legacyCutoffDate = new Date('08/27/2018').getTime();
		state.isLegacyLoan = payload.data <= legacyCutoffDate;

	},

	addDefaultOption: (state, payload) => { // payload is the name of a store scenario variable(string)
		for (let field of state[payload].fields) {
			if (field.required === false && field.type === 'text') {
				const fieldOptions = field.options.map(f => f.toLowerCase());
				if (!fieldOptions.includes('none')) {
					field.options.unshift("None");
				}
			}
		}
	},

	convertRuleDates: (state, payload) => { // payload is the name of a store scenario variable(string)
		for (let rule of state[payload].rules) {
			for (let field of rule.fields) {
				field = convertToReadableDate(field, state[payload].fields);
			}
		}
	},

	setScenarioValid: (state, payload) => { // payload is the name of a store scenario variable(string)
		// sets the result of the scenario
		let allValid = state[payload].rules.every(rule => rule.valid === true || rule.override !== undefined);

		// prevents success from being displayed if the scenario has never been saved
		if (state[payload].rules.length < 1) {
			allValid = null;
		}
		Vue.set(state[payload], "valid", allValid);
	},

	setSelectedLoanId: (state, payload) => { // payload is an ID string
		// sets the selected ID of the scenario
		state.selectedLoanId = payload;
	},

	setCompareOptions: (state, payload) => { // payload is a list of {scenarioId, timeCreated}
		state.compareOptions = payload.map(o => ({ created: new Date(o.created).toLocaleString(), id: o.id }));
	},

	setEncompassValues: (state, payload) => { // payload is {scenario: scenario freshly pulled from db, created: date loan was created}
		// sets the values of the scenario's encompass values
		state.haloScenario.fields = payload.scenario.fields;
	},

	updateScenarioResults: (state, payload) => { // payload is {scenario: name of scenario in store(string), data: newResults from program object retrieved from QuickQuote after being altered by fixRules}
		// TODO: update this to handle nested fields
		// updates the rules and their results for the scenario
		state[payload.scenario].rules = [...payload.data.failedRules, ...payload.data.passedRules];

		// for each rule
		for (let rule of state[payload.scenario].rules) {
			// for each field in a rule
			for (let field of rule.fields) {
				// find the field in the scenario by name
				const currField = state[payload.scenario].fields.find(f => f.name === field.name);
				// if the field exists in the scenario and it a date field
				if (currField && currField.type === 'date') {
					// convert the date value to a date string
					field.value = convertToString(currField.dateValue);
				}
			}
		}

		// updates the compensating factors and their results for the scenario
		let compFactors = [...payload.data.passedCompensatingFactors, ...payload.data.failedCompensatingFactors];
		
		// adds both 'other' compensating factors if they exist
		const otherCompFactor = state.haloScenario.compensatingFactors.find(cf => cf.name === 'Other' || cf.name === 'Other 1');
		if (otherCompFactor) {
			compFactors.push(otherCompFactor);
		} else {
			compFactors.push({
				fields: [],
				manager: true,
				message: "Manager required",
				name: "Other 1",
				valid: false,
				valueMessage: ""
			});
		}

		const otherCompFactor2 = state.haloScenario.compensatingFactors.find(cf => cf.name === 'Other 2');
		if (otherCompFactor2) {
			compFactors.push(otherCompFactor2);
		} else {
			compFactors.push({
				fields: [],
				manager: true,
				message: "Manager required",
				name: "Other 2",
				valid: false,
				valueMessage: ""
			});
		}

		// set the array of compensating factors to be all the passing factors, all the failing factors and the 'other' comp factors
		state[payload.scenario].compensatingFactors = compFactors;

		// for each comp factor
		for (let compFactor of state[payload.scenario].compensatingFactors) {
			// for each field in a comp factor
			for (let field of compFactor.fields) {
				// find the field in the scenario by name
				const currField = state[payload.scenario].fields.find(f => f.name === field.name);
				// if the field exists in the scenario and it a date field
				if (currField && currField.type === 'date') {
					// convert the date value to a date string
					field.value = convertToString(currField.dateValue);
				}
			}
		}

		// update the adjustments and their results for the scenario
		state[payload.scenario].adjustments = payload.data.adjustments;
	},

	// TODO: Should be handled by DB now. If date errors occur when fetching scenario add this back in
	// dateToString: (state, payload) => { // payload is the name of a scenario variable in the store(string)
	// 	for (let field of state[payload].fields) {
	// 		if (field.type === "date") {
	// 			field = convertToString(field.dateValue);
	// 			console.log('datetoSTring', field)
	// 		}
	// 		console.log()
	// 	}
	// },

	updateScenarioTime: (state, payload) => { // payload is the name of a scenario variable in the store(string)
		// get the time the scenario was saved
		Vue.set(state[payload], "created", Date.now());
	},

	setHasRun: (state, payload) => { // payload is a boolean value
		// sets if the scenario has been run and stores the current value
		state.wasRun = state.hasRun
		state.hasRun = payload;
	},

	toggleAnimation(state) {
		if (!state.wasRun && state.hasRun) {
			state.rulesAnimationState = !state.rulesAnimationState
		}
		return state.rulesAnimationState
	},

	setSaved: (state, payload) => { // payload is a boolean value
		// sets if the scenario has been saved
		state.saved = payload;
	},

	setSelectedSectionName: (state, payload) => { // payload is section name
		// sets the name of the currently selected section
		state.selectedSection.name = payload;
	},

	setInvalidSections: (state, payload) => { // payload is {scenario: name of scenario variable (string), errors: list of error messages from a vuelidate validator}
		// if no payload is passed then the invalid sections are cleared
		if (payload.scenario === 'toolScenario') {
			if (!payload.errors) {
				state.toolInvalidSections = [];
			} else {
				for (let param of payload.errors) {
					if (param.$message && param.$message !== 'override') {
						const invalidField = state[payload.scenario].fields.find(f => f.param === param.$message);
						state.toolInvalidSections = [...new Set([...invalidField.sections, ...state.toolInvalidSections])];
					}
				}
			}
		} else {
			if (!payload.errors) {
				state.haloInvalidSections = [];
			} else {
				for (let param of payload.errors) {
					if (param.$message && param.$message !== 'override') {
						const invalidField = state[payload.scenario].fields.find(f => f.param === param.$message);
						state.haloInvalidSections = [...new Set([...invalidField.sections, ...state.haloInvalidSections])];
					}
				}
			}
		}
	},

	setSelectedRule(state, payload) { // payload is {scenario: name of scenario variable (string), row: rule name}
		// sets a selected rule
		state.selectedRule = state[payload.scenario].rules.find(r => r.name === payload.row);
	},

	updateSelectedRule(state) {
		// updates selected rule
		let ruleIndex = state.haloScenario.rules.findIndex(r => r.ruleId === state.selectedRule.ruleId);
		Vue.set(state.haloScenario.rules, ruleIndex, state.selectedRule);
	},

	setRuleOverride(state, payload) {
		// sets the override value of the selected rule
		state.selectedRule['override'] = payload;
	},

	editOverride(state, payload) { // payload is {override property prop, value}
		// edits a property of the override currently being created or editted
		state.currentOverride[payload.prop] = payload.value
	},

	setCurrentOverride(state, payload) { // payload is an override object
		// creates an override object to be used when making or viewing an exception
		if (!payload) {
			state.currentOverride = {
				guideline: "",
				actualValue: "",
				comment: "",
				grantedByUserId: "",
				grantedByUsername: "",
				grantedByDate: null,
				userId: "",
				username: "",
				created: null,
				category: "",
				type: "",
				confirmed: false,
				sendToCrse: true
			}
		} else {
			state.currentOverride = payload
		}
	},

	findChangesInExceptions(state) {
		// checks for changes in exceptions between the most recent scenario and the one that was just run
		// variable for storing if a difference is found across all rules. if set to true display an alert for users
		state.displayValueChangeMessage = false;
		// variable for storing if there are enough comp factors to make an exception. if set to true display an alert for users
		state.displayCompFactorMessage = false;

		// check all rules from most recently saved scenario
		for (let rule of state.compareScenario1.rules) {
			// variable for storing if a difference is found in the current rule. used for passing exception to new scenario if no differences are found
			let foundDiff = false;
			// if the rule has an override check values
			if (rule.override) {
				// set the override to be confirmed, can be overwritten if a difference is found
				rule.override.confirmed = true;
				// find a rule in the scenario with the same name as the one being checked
				let scenarioRuleIndex = state.haloScenario.rules.findIndex(r => r.ruleId === rule.ruleId);
				// if the rule exists
				if (scenarioRuleIndex !== -1) {
					// get a copy of the matching rule from the index
					let scenarioRuleCopy = JSON.parse(JSON.stringify(state.haloScenario.rules[scenarioRuleIndex]));
					// if the new scenario rule is now valid
					if (scenarioRuleCopy.valid) {
						// go to the next iteration because that rule should no longer have an exception to compare
						continue;
					}
					// if the old rule does not have a rule version or if the new rule version is different than the old rule version set foundDiff to be true an skip the other steps
					if (scenarioRuleCopy.version !== rule.version) {
						foundDiff = true
					// if the new rule is the same version as the old rule
					} else {
						// check each value in the override
						for (let field of rule.fields) {
							// find the same field in the new scenario
							const scenarioFieldIndex = scenarioRuleCopy.fields.findIndex(f => f.name === field.name);
							const scenarioField = scenarioRuleCopy.fields[scenarioFieldIndex];
							// if that field exists in the new scenario
							if (scenarioField) {
								foundDiff = !_.isEqual(scenarioField, field) || foundDiff;
							}
							// since fields can have the same name remove the field checked so it is not pulled again
							scenarioRuleCopy.fields.splice(scenarioFieldIndex, 1);
						}
					}
					// if differences in exception values are found
					if (foundDiff) {
						// if a difference was found in a rule, then set alert to be displayed
						state.displayValueChangeMessage = true;
						rule.override.confirmed = false;
					}

					// if the rule requires at least 2 compensating factors but doesn't have that many
					if (rule.exceptionLevel >= 2 && state.passingCompFactorLength < 2) {
						// set the message to alert the user they don't have enough compensating factors
						state.displayCompFactorMessage = true;
					}

					// if the rule exists in the new scenario and is invalid
					if (!state.haloScenario.rules[scenarioRuleIndex].valid) {
						// set the new scenario rule to have the same exception as the old one
						Vue.set(state.haloScenario.rules[scenarioRuleIndex], 'override', rule.override);
					}
				}
			}
		}
	},

	setPassingCompFactorLength(state) {
		// sets the number of passing compensating factors. Includes the special cases where some don't count even if the rule passes.
		const passingCompFactors = state.haloScenario.compensatingFactors.filter(cf => cf.valid === true);
		state.passingCompFactorLength = passingCompFactors.length;
		const programField = state.haloScenario.fields.find(f => f.name === 'Program');

		// If Credit Score and Credit History are both present then only one of them counts
		let creditCases = passingCompFactors.filter(cf => cf.name === 'Credit Score' || cf.name === 'Credit History');
		if (creditCases.length === 2) {
			state.passingCompFactorLength --;
		}

		// If the program is Bank Statement then DTI and Residual Income don't count
		if (programField && programField.textValue === 'Bank Statement') {
			let bankStatementCases = passingCompFactors.filter(cf => cf.name === 'DTI' || cf.name === 'Residual Income');
			state.passingCompFactorLength -= bankStatementCases.length;
		}

		// If an exception has the type 'Minimum Trade Lines' then Credit Score and Credit History do not count
		let rulesWithExceptions = state.haloScenario.rules.filter(r => !!r.override);
		if (rulesWithExceptions.find(r => r.override.type === 'Minimum Trade Lines') || state.currentOverride.type === 'Minimum Trade Lines') {
			const passingCompFactors = state.haloScenario.compensatingFactors.filter((cf) => cf.valid === true);
            const tradelineCases = passingCompFactors.filter(cf => cf.name === 'Credit Score' || cf.name === 'Credit History');
            // Since credit score and credit history only count as 1 together only remove 1 from length
			if (tradelineCases.length > 0) {
				state.passingCompFactorLength--;
			}
		}
	},

	removeRuleOverrides(state) {
		// used to remove overrides from rules if there are less than two compensating factors or if a rule is not confirmed
		for (let rule of state.haloScenario.rules) {
			// if a rule has an override, but there are less than 2 comp factors and it requires 2 comp factors or the override was not confirmed
			if (rule.override && ((state.passingCompFactorLength < 2 && rule.exceptionLevel >= 2) || !rule.override.confirmed || rule.valid)) {
				// remove the override
				const ruleIndex = state.haloScenario.rules.findIndex(r => r.ruleId === rule.ruleId);
				Vue.set(state.haloScenario.rules[ruleIndex], 'override', null);
			}
		}
	},

	setCurrentCompFactor(state, payload) { // payload is the name of a compensating factor
		// sets a temporary comp factor object to be editted. Used to create/view the 'Other' comp factor
		const otherCompFactor = state.haloScenario.compensatingFactors.find(cf => cf.name === payload);
		if (!otherCompFactor.valid) {
			state.currentCompFactor = {
				fields: [],
				manager: true,
				message: "Manager required",
				name: payload,
				valid: false,
				valueMessage: ""
			}
		} else {
			state.currentCompFactor = otherCompFactor;
		}
	},

	editCurrentCompFactor(state, payload) { // payload is a { prop: comp factor prop name, value: value for prop to be changed to }
		state.currentCompFactor[payload.prop] = payload.value;
	},

	setOtherCompFactor(state, payload) { // payload is the name of a compensating factor
		// sets the 'other' compensating factor to contain the values of the comp factor that was being editted
		const otherCompFactorIndex = state.haloScenario.compensatingFactors.findIndex(cf => cf.name === payload);
		Vue.set(state.haloScenario.compensatingFactors, otherCompFactorIndex, state.currentCompFactor);
	},

	resetOtherCompFactor(state, payload) { // payload is the name of a compensating factor
		// resets the 'other' compensating factor to fail and have a message of 'manager required'
		const otherCompFactorIndex = state.haloScenario.compensatingFactors.findIndex(cf => cf.name === payload);
		Vue.set(
			state.haloScenario.compensatingFactors,
			otherCompFactorIndex,
			{
				"name": payload,
				"message": "Manager required",
				"valueMessage": "",
				"manager": true,
				"valid": false,
				"fields": []
			}
		);
	},

	encompassSave(state) {
		// called by encompass to save the result of QDU
		let saveSuccess = false;
		try {
			// TODO: make a copy of the getters since they are being overwritten. remove parse and stringify once stopcap is removed
			const crseObject = JSON.parse(JSON.stringify(this.getters.getRulesToCrse));
			for (let rule of crseObject.rules) {
				rule.override.created = new Date(rule.override.created).getTime();
				rule.override.grantedByDate = new Date(rule.override.grantedByDate).getTime();
				let fields = [];
				for (let field of rule.fields) {
                    // add the fields recursively if the field has children
                    if (field.children) {
                        fields = addFieldToList(field, fields, [], true);
                    // if the field does not have children just add the name and value to the list
                    } else {
                        fields.push({
                            name: field.name,
                            value: field.value,
							param: field.param,
							valid: field.valid
                        });
                    }
                }
				rule.fields = fields;
			}
			console.log(crseObject);
			console.log("Found window: " + !!window);
			console.log("Found plugin functions: " + !!(window?.PluginFunctions));
			// eslint-disable-next-line no-undef
			saveSuccess = window.PluginFunctions.SendExceptionsToCrse(state.haloScenario.valid, crseObject);
		} catch (err) {
			console.warn("save scenario not found.");
		} finally {
			state.saveSuccess = saveSuccess;
		}
	},
};